export default defineNuxtRouteMiddleware((to, _from) => {
  const kcseResultsStore = useKcseResultsStore();
  const { results } = storeToRefs(kcseResultsStore);

  // Only proceed if results exist
  if (results.value) {
    const { meanGrade, cluster_points } = results.value;

    // Determine the grade positions for comparison.
    // If the grade exists in our array, a lower index means a better grade.
    const meanGradeIndex = kcseGrades.indexOf(meanGrade);
    const thresholdIndex = kcseGrades.indexOf("C+");

    // Check if meanGrade is valid and C+ or above.
    // (i.e. its index is less than or equal to that of "C+")
    if (meanGradeIndex !== -1 && meanGradeIndex <= thresholdIndex) {
      // If there are no cluster points, redirect to /clusterpoints
      if (
        !cluster_points ||
        cluster_points?.saved === undefined ||
        !cluster_points.saved
      ) {
        return navigateTo("/clusterpoints");
      }
    }
  }
});

const kcseGrades = [
  "A",
  "A-",
  "B+",
  "B",
  "B-",
  "C+",
  "C",
  "C-",
  "D+",
  "D",
  "D-",
  "E",
];
